<template>
	<section class="small-12 columns settingsContent residentsSiteInformation" v-if="user">
		<div class="small-12" v-if="company">
			<div class="small-12 large-8 columns">
				<div class="small-12 formBox">
					<div class="small-12 wrap border borderRadius8">
						<div class="small-12 columns title">
							<h2>Residents Site URL</h2>
						</div>
						<div class="small-12 columns description">
							<p>
								If you need a quick way to grab the link to your resident's site, click the copy button below. If you would like to visit your site, click the visit button and you will be directed to your site.
							</p>
						</div>
						<div class="small-12 columns formBody">
							<ul class="small-12 flex">
								<li class="small-12">
									<label class="small-12">Site Link</label>
									<input type="text" name="site_link" class="small-12 readOnly" :value="site_link" readonly>
								</li>
								<li class="small-12 action flex justify-center">
									<a class="greyButton flex vertical-align justify-center borderRadius4" @click="copyToClipboard()">
										<i class="material-icons-outlined addIcon borderRadius4 flex justify-center vertical-align">content_copy</i> 
										Click to Copy
									</a>
									<a :href="site_link" target="_blank" class="blueButton flex vertical-align justify-center borderRadius4">
										<i class="material-icons-outlined addIcon borderRadius4 flex justify-center vertical-align">view_compact</i> 
										Visit Resident's Site
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<div class="small-12 large-6 columns">
			</div>
		</div>
		<div class="small-12 columns widget emptyWidget" v-else>
			<div class="small-12 widgetChart borderRadius20 flex vertical-align" style="padding: 0px;">
				<div class="small-12 wrap" style="padding: 40px;">
					<picture class="small-12 flex justify-center">
						<img width="300" :src="empty_company_image" alt="Empty Coffee Cup">
					</picture>
				</div>
				<div class="small-12 emptyDetails">
					<h6 class="small-12 text-center">No Company Found</h6>
					<p class="small-12 text-center">Please enter in your company's information.</p>
				</div>
				<div class="small-12 action flex justify-center" style="margin-top:30px;">
					<router-link :to="{ name: 'AddCompany' }" class="primaryButton flex justify-center borderRadius8">
						Add Company Details
					</router-link>
				</div>
			</div>
		</div>
	</section>
</template>

<script>

	// Import firebase
	import { firebaseAuth, companiesModel } from '@/firebase/firebase-config'

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

	// Import the components
	import UserFooter from '@/components/framework/footer/UserFooter.vue'
	import LoadingSpinner from '@/components/framework/helpers/LoadingSpinner.vue'
	import PrimaryNav from '@/components/framework/nav/PrimaryNav.vue'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'ResidentsSiteInformation',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService

		],

		/*
		**  Set the props
		*/

		props: {

			user: {
				type: Object,
				default: () => null
			}

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			company: null,
			empty_company_image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/vectors%2Fempty-coffee-cup.svg?alt=media&token=354363eb-6fc1-4f78-a3d0-57180233fcd4',
			site_link: process.env.VUE_APP_RESIDENTS_URL

		}),

		/*
		**  Watch em'
		*/

		watch: {

			user: {

				immediate: true, // Load on created
				handler(user) {

					// Get the company info
					if (user) this.getCompany();

				}

			}

		},

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

			getCompany: function() {

				// Get the company
				companiesModel.doc(this.user.relationships.company).get()
				.then(doc => {

					if (!doc.exists) return;

					// Set the prop
					this.company = doc.data();

				})
				.catch(error => {

					// Send to bugsnag
					this.reportAuthBugsnagError({
						title: 'Residents Site Information - Get Company Document',
						errorType: 'Firestore Database',
						section: 'Settings Company',
						component: 'ResidentsSiteInformation',
						error: error
					});

				});

			},

			copyToClipboard: function(){

				// Set the vars
				let $temp = $('<input>'),
					inputText = $('input[name="site_link"]');

				// Place the focus on the input
				inputText.focus();

				// Select the input
				inputText.select();
				
				// Copy the text inside the field
				document.execCommand('copy');

				// Show the alert
				this.$swal('Go Get Em!', 'Your link has been saved to your clipboard.', 'success');
				
			},

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>